import { useEffect, useState } from 'react';
import { getCountdownParts, msUntilNextChange } from './countdown';

// Lands past the boundary so a timer that fires early doesn't re-tick the old value.
const PAST_BOUNDARY_MS = 50;

const useCountdown = targetMs => {
	const [tick, setTick] = useState(() => ({ targetMs, now: Date.now() }));
	const now = tick.targetMs === targetMs ? tick.now : Date.now();

	useEffect(() => {
		if (targetMs === null) return undefined;
		let timer;
		const sync = () => {
			clearTimeout(timer);
			const current = Date.now();
			setTick({ targetMs, now: current });
			const delay = msUntilNextChange(targetMs, current);
			if (delay !== null) timer = setTimeout(sync, delay + PAST_BOUNDARY_MS);
		};
		const syncWhenVisible = () => {
			if (document.visibilityState === 'visible') sync();
		};
		sync();
		document.addEventListener('visibilitychange', syncWhenVisible);
		return () => {
			clearTimeout(timer);
			document.removeEventListener('visibilitychange', syncWhenVisible);
		};
	}, [targetMs]);

	return targetMs === null ? null : getCountdownParts(targetMs, now);
};

export default useCountdown;
